"use strict";

import "./CrossingCard.css";
import React from "react";
import classnames from "classnames";
import lang from "vwa/lang";
import Card from "vwa/components/Card";
import Pin from "vwa/components/Pin";
import Icon from "vwa/components/Icon";

export default class CrossingCard extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			expanded: false
		};
	}
	
	toggle() {
		this.setState({
			expanded: !this.state.expanded
		});
	}
	
	handlePOINameClick(evt, which) {
		evt.stopPropagation();
		this.props.onPOINameClick(which);
	}
	
	render() {
		const dateTimeString = (new Date(this.props.crossing.time)).toLocaleString();
		const poiName = poiStore.get(this.props.crossing.poi).name;
		
		return (
			<Card
				className="CrossingCard"
				onClick={() => this.props.onClick()}
				onMouseEnter={() => this.props.onMouseEnter()}
				onMouseLeave={() => this.props.onMouseLeave()}
			>
				<div className="InfoContainer">
					<div className="IconContainer">
						<Icon>{this.props.crossing.inside ? "login" : "logout"}</Icon>
					</div>
					<div className="DateContainer">
						<label>{dateTimeString}</label>
					</div>
					<div className="AddressContainer">
						<label onClick={evt => {
							evt.stopPropagation();
							this.props.onPOINameClick(evt, this.props.crossing.time);
						}}>
							{poiName}
						</label>
					</div>
				</div>
			</Card>
		);
	}
	
}

CrossingCard.propTypes = {
	crossing:		React.PropTypes.object,
	onClick:		React.PropTypes.func,
	onMouseEnter:	React.PropTypes.func,
	onMouseLeave:	React.PropTypes.func,
	onPOINameClick:	React.PropTypes.func
};

CrossingCard.defaultProps = {
	crossing:		null,
	onClick:		() => {},
	onMouseEnter:	() => {},
	onMouseLeave:	() => {},
	onPOINameClick:	which => {}
};


// WEBPACK FOOTER //
// ./src/view/VehiclePOICrossingsTimeline/CrossingCard/CrossingCard.jsx